"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _forgot = _interopRequireDefault(require("./forgot"));

var _login = _interopRequireDefault(require("./login"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      alignItems: 'center',
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      width: '100%'
    },
    logo: {
      marginBottom: '5rem',
      width: '20%'
    },
    container: {
      maxWidth: '400px',
      padding: theme.spacing(4),
      textAlign: 'center',
      width: '100%'
    }
  };
});

var _default = function _default(_ref) {
  var handleForgot = _ref.handleForgot,
      handleLogin = _ref.handleLogin,
      logo = _ref.logo;
  var classes = useStyles();

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      forgot = _React$useState2[0],
      setForgot = _React$useState2[1];

  return _react["default"].createElement("div", {
    className: classes.root
  }, _react["default"].createElement("div", {
    className: classes.container
  }, _react["default"].createElement("img", {
    className: classes.logo,
    src: logo
  }), !forgot ? _react["default"].createElement(_login["default"], {
    handleLogin: handleLogin,
    toggle: function toggle() {
      return setForgot(!forgot);
    }
  }) : _react["default"].createElement(_forgot["default"], {
    handleForgot: handleForgot,
    toggle: function toggle() {
      return setForgot(!forgot);
    }
  })));
};

exports["default"] = _default;